import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/transportColumns";
const defaultQuery = {
    orderBy: "id desc",
};

const list = (params: {}) => request(`${resource}/getList${containsQuery(params)}`, { method: "GET" });

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getlist${query}&withDeleted=true`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(
        `${resource}/getListExcel?${query}&withDeleted=true`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Транспортные колонны.xlsx"));
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const getItem = ({ id }: { id: number }) => request(`${resource}/get/${id}`, { method: "GET" });

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));

export { list, apply, index, getItem, delItem, restore, getListExcel };
